import React, { useState } from "react";
import AppBody from "../../components/AppBody";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAssignedCourseUserList } from "../../../actions/course/assign_course/assign_course_action";

const AssignCourseUserList = () => {
  const state = useSelector((state) => state.assignCourseReducer);
  const dispatch = useDispatch();
  const { slug } = useParams();

  useEffect(() => {
    dispatch(getAssignedCourseUserList({ slug: slug }));
  }, []);

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/all-courses"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Assign Course Users List
              </h4>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.assignedCourseUserList &&
                      state.assignedCourseUserList.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.first_name +" "+li.last_name}</td>
                          <td>{li.email}</td>
                          <td>{li.start_date}</td>
                          <td>{li.end_date}</td>
                          <td>
                            {li.is_complete === 0 ? "Incomplete" : "Completed"}
                          </td>
                          {/*<a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                              onClick={() => updateUserProfile(li.slug)}
                            >
                              <i className="feather-edit"></i>
                            </a>*/}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssignCourseUserList;
